import { instance, instance2 } from '@/api/index';

/** 사용자 디바이스 목록
 * @param datas
 */
function fetchDeviceListByUser(datas) {
  return instance.post('/api/devices/getDeviceListByUser', datas);
}

/** 사용자 선택 디바이스 간략 정보
 * @param datas
 */
function fetchDeviceSimpleInfo(datas) {
  return instance.post('/api/devices/getDeviceSimpleInfo', datas);
}

/** 디바이스 시스템 정보
 * @param datas
 */
function fetchDeviceSystemInfo(datas) {
  return instance2.post('/api/monitoring/list', datas);
}

/** 디바이스 시스템 상태 수치
 * @param datas
 */
function fetchDeviceSystemStatus(datas) {
  return instance2.post('/api/devices/getDeviceStatus', datas);
}

/** 사용자 선택 디바이스 디테일 정보
 * @param datas
 */
function fetchDeviceInfo(datas) {
  return instance2.post('/api/devices/getDeviceInfo', datas);
}

/** 디바이스 인터페이스 정보
 * @param datas
 */
function fetchDeviceInterfaceInfo(datas) {
  return instance2.post('/api/monitoring/getDeviceInterfaceInfo', datas);
}

export {
  fetchDeviceListByUser,
  fetchDeviceSimpleInfo,
  fetchDeviceSystemInfo,
  fetchDeviceSystemStatus,
  fetchDeviceInfo,
  fetchDeviceInterfaceInfo,
};
